import VideoService from 'app_services/video/videoService'
import { IMediaData } from 'app_types/media/media.types'
import parse from 'html-react-parser'
import React, { CSSProperties, useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { IoIosCloseCircleOutline } from 'react-icons/io'

import { useResizeDetector } from 'react-resize-detector'
import './../modalMedia.scss'

interface IModalMediaLayoutProps {
  media: IMediaData
  open: boolean
  className?: string
  style?: CSSProperties
  showName?: boolean
  showDescription?: boolean
  hideCloseButton?: boolean
  onClose?: ()=>any
}

const ModalMediaLayout: React.FC<IModalMediaLayoutProps> = (props) => {

  const [mediaComponent, updateMediaComponent] = useState<any>(undefined)

  // @INFO Servicios
  const videoService = new VideoService()

  /**
   * @INFO Renderizar el componente según el tipo de media
   * @returns
   */
  const renderComponent = () => {
    const type = props.media?.type
    const url = props.media?.url
    if(!type || !url) return null
    if(mediaComponent) return mediaComponent
    switch(type){
      case 'vimeo':
      case 'youtube':
        const component = (
          <>
            {props.showDescription || props.showName ?
              <div className='content-title-video'>
                {props.showName ? <p>{props.media.name}</p>:null}
                {/* {props.showDescription ? <p>{props.media.description ? parse(props.media.description) : ''}</p>:null} */}
              </div>
            :null}
            {videoService.renderByPlatform(
              type,
              url,
              {
                autoplay: true,
                onEnd: props.onClose,
              },
            )}
            <div className='container-text'>
              {/* {props.showName ? <p>{props.media.name}</p>:null} */}
              {props.showDescription ? <p className='description-container-text' >{props.media.description ? parse(props.media.description) : ''}</p>:null}
            </div>
          </>
        )
        updateMediaComponent(component)
        return component
      default:
        return null
    }
  }

  /**
   * @INFO Click en cerrar
   */
  const handleClickClose = () => {
    if(props.onClose){
      props.onClose()
    }
  }

    return (
      <Modal
        show={props.open}
        onHide={handleClickClose}
        // backdrop='static'
        // keyboard={false}
        centered
        className={`modal_media-component ${props.className ? props.className : ''}`}
        style={props.style}
        dialogClassName='modal-dialog-container'
      >
        <Modal.Body
          className='modal-media-body'
        >
          {!props.hideCloseButton ?
            <div className='close-icon-container'>
              <IoIosCloseCircleOutline
                className='close-icon'
                onClick={handleClickClose}
              />
            </div>
          :null}
          {renderComponent()}
        </Modal.Body>
      </Modal>
    )
}

export default ModalMediaLayout
